import { action, computed, makeObservable, observable } from 'mobx';
import { parseQuery } from '../core/helpers/parseQuery';
import { DefaultQueryParams } from '../core/constants/defaultQueryParams';
import { GameModes } from '../core/constants/gameModes';
import { canvasTranslationKeys as canvasTranslationKeysEnum } from '../core/constants/canvasTranslationKeys';

export class ApplicationStore {
  bonusType = null;

  accessToken = '';

  isMaintenance = false;

  isSoundsLoaded = false;

  isAuthenticated = false;

  isShowLicenseMode = false;

  isShowPayTableMode = false;

  isAuthDataReceived = false;

  isCheckBalanceOnBet = false;

  isOperatorHandlesErrors = false;

  isSkipSpinAfterBetChange = false;

  canvasTranslationKeys = {};

  iconsInfo = [];

  isShowBlackLayer = false;

  isShowMobileBigWinLayer = false;

  constructor() {
    makeObservable(this, {
      isDemo: computed,
      bonusType: observable,
      accessToken: observable,
      isMaintenance: observable,
      isShowBlackLayer: observable,
      isSoundsLoaded: observable,
      isAuthenticated: observable,
      isShowLicenseMode: observable,
      isShowPayTableMode: observable,
      isAuthDataReceived: observable,
      isCheckBalanceOnBet: observable,
      isShowMobileBigWinLayer: observable,
      isOperatorHandlesErrors: observable,
      isSkipSpinAfterBetChange: observable,
      iconsInfo: observable.deep,
      canvasTranslationKeys: observable.deep,
      setIsDemo: action.bound,
      setBonusType: action.bound,
      setIconsInfo: action.bound,
      setAccessToken: action.bound,
      setIsMaintenance: action.bound,
      setIsSoundsLoaded: action.bound,
      setIsAuthenticated: action.bound,
      setIsShowBlackLayer: action.bound,
      setIsShowLicenseMode: action.bound,
      setIsShowPayTableMode: action.bound,
      setIsAuthDataReceived: action.bound,
      setIsCheckBalanceOnBet: action.bound,
      setIsOperatorHandlesErrors: action.bound,
      setIsShowMobileBigWinLayer: action.bound,
      setIsSkipSpinAfterBetChange: action.bound,
      setTranslationsTextInCanvas: action.bound,
    });
  }

  setIsSkipSpinAfterBetChange(bool) {
    this.isSkipSpinAfterBetChange = bool;
  }

  setIsOperatorHandlesErrors(bool) {
    this.isOperatorHandlesErrors = bool;
  }

  setIsShowMobileBigWinLayer(bool) {
    this.isShowMobileBigWinLayer = bool;
  }

  setIsShowBlackLayer(bool) {
    this.isShowBlackLayer = bool;
  }

  setIconsInfo(data) {
    this.iconsInfo = data;
  }

  setBonusType(bonusType) {
    this.bonusType = bonusType;
  }

  setIsMaintenance(bool) {
    this.isMaintenance = bool;
  }

  setIsDemo(boolValue) {
    this.isDemo = boolValue;
  }

  setIsSoundsLoaded(bool) {
    this.isSoundsLoaded = bool;
  }

  setAccessToken(accessToken) {
    this.accessToken = accessToken;
  }

  setIsAuthenticated(isAuthenticated) {
    this.isAuthenticated = isAuthenticated;
  }

  setIsAuthDataReceived(isAuthDataReceived) {
    this.isAuthDataReceived = isAuthDataReceived;
  }

  setIsShowLicenseMode(bool) {
    this.isShowLicenseMode = bool;
  }

  setIsCheckBalanceOnBet(bool) {
    this.isCheckBalanceOnBet = bool;
  }

  setIsShowPayTableMode(bool) {
    this.isShowPayTableMode = bool;
  }

  setTranslationsTextInCanvas(translations) {
    this.canvasTranslationKeys = Object.keys(canvasTranslationKeysEnum).reduce((acc, current) => {
      if (translations[current]) {
        acc[current] = translations[current];
      }
      return acc;
    }, {});
  }

  get isDemo() {
    const { [DefaultQueryParams.Mode]: mode } = parseQuery(window.location.search);
    return mode === GameModes.Fun;
  }
}

export const applicationStore = new ApplicationStore();
